import { DatePipe } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { BlockUIModule } from 'primeng/blockui';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { MessageModule } from 'primeng/message';
import { DropdownModule } from 'primeng/dropdown';
import { CheckboxModule } from 'primeng/checkbox';
import { MultiSelectModule } from 'primeng/multiselect';
import { MenubarModule } from 'primeng/menubar';
import { TooltipModule } from 'primeng/tooltip';
import { KeyFilterModule } from 'primeng/keyfilter';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { CardModule } from 'primeng/card';
import { CarouselModule } from 'primeng/carousel';
import { RadioButtonModule } from 'primeng/radiobutton';
import { AccordionModule } from 'primeng/accordion';
import { OrderListModule } from 'primeng/orderlist';
import { DataViewModule } from 'primeng/dataview';
import { ButtonModule } from 'primeng/button';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { TabViewModule } from 'primeng/TabView';
import { AppComponent } from './app.component';
import { DataService, UIBlockingStatus } from './common/data.service';
import { AuthGuardService } from './common/auth-guard.service';
import { AppTokenHandler, HTTPStatus, UserInfo } from './common/app-token-handler';
import { ErrorHandler } from '@angular/core';
import { AppErrorHandler } from './common/app-error-handler';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClientJsonpModule } from '@angular/common/http';
import { FileUploadModule } from 'primeng/fileupload';
import { WinAuthInterceptor } from './common/interceptor';
import { HomeComponent } from '../app/inside-of-application/home/home.component';
import { DashboardComponent } from './inside-of-application/dashboard/dashboard.component';
import { BadRequestComponent } from '../app/out-of-application/bad-request/bad-request.component';
import { PageNotFoundComponent } from '../app/out-of-application/page-not-found/page-not-found.component';
import { LogoutComponent } from '../app/out-of-application/logout/logout.component';
import { UnAuthorizeComponent } from '../app/out-of-application/un-authorize/un-authorize.component';
import { SessionExpiredComponent } from './out-of-application/session-expired/session-expired.component';
import { LoginComponent } from './out-of-application/login/login.component';
import { DummyLoginComponent } from './out-of-application/dummy-login/dummy-login.component';
import { AlertComponent } from './out-of-application/alert/alert.component';
import { ProgressComponent } from './out-of-application/progress/progress.component';
import { ResumeComponent } from './inside-of-application/resume/resume.component';
import { SearchResumeComponent } from './inside-of-application/search-resume/search-resume.component';
import { ConsentComponent } from './out-of-application/consent/consent.component'
import { Global } from './Global';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatTabsModule } from '@angular/material/tabs';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatDialogModule } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
// import {MatOptionModule}from '@angular/material/select';
import { AddDelegateComponent } from './inside-of-application/delegate/add-delegate/add-delegate.component';
import { ViewDelegateComponent } from './inside-of-application/delegate/view-delegate/view-delegate.component';
import { CreateResumeComponent } from './inside-of-application/resume/create-resume/create-resume.component';
import { MyResumeComponent } from './inside-of-application/resume/my-resume/my-resume.component';
import { ResuemeCartComponent } from './inside-of-application/resueme-cart/resueme-cart.component';
import { CalendarModule } from 'primeng/calendar';
import { AppInsightsService } from './common/app-insights.service';
import { environment } from 'src/environments/environment';
@NgModule({
    declarations: [
        AppComponent, HomeComponent, DashboardComponent,
        BadRequestComponent, PageNotFoundComponent, LogoutComponent, UnAuthorizeComponent,
        SessionExpiredComponent, LoginComponent, DummyLoginComponent, AlertComponent,
        ProgressComponent, ResumeComponent, AddDelegateComponent, ViewDelegateComponent,
        CreateResumeComponent, MyResumeComponent, SearchResumeComponent, ResuemeCartComponent, ConsentComponent
    ],
    imports: [
        AppRoutingModule, HttpClientModule, ToastModule, MessageModule, CheckboxModule, MultiSelectModule, MenubarModule, TooltipModule,
        KeyFilterModule, DialogModule, TableModule, CardModule,
        CarouselModule, BlockUIModule, ProgressSpinnerModule, RadioButtonModule,
        AccordionModule, OrderListModule, DataViewModule, ButtonModule, InputTextareaModule,
        AutoCompleteModule, TabViewModule, MatSortModule, DropdownModule,
        MatButtonModule, MatCheckboxModule, MatDialogModule,
        MatIconModule, MatPaginatorModule, BrowserModule,
        FormsModule, ReactiveFormsModule, AngularMultiSelectModule, MatProgressSpinnerModule,
        MatMenuModule, MatToolbarModule, MatCardModule, FileUploadModule,
        BrowserAnimationsModule, MatFormFieldModule, MatDatepickerModule,
        MatNativeDateModule, MatRadioModule, MatSelectModule,
        // MatOptionModule, 
        MatSlideToggleModule,
        MatInputModule, MatTableModule, CalendarModule, MatTabsModule, MatTooltipModule, HttpClientJsonpModule
    ],
    providers: [
        DataService, Global, AppTokenHandler, AuthGuardService, UIBlockingStatus, MessageService, AppErrorHandler, HTTPStatus,
        { provide: HTTP_INTERCEPTORS, useClass: WinAuthInterceptor, multi: true },
        { provide: ErrorHandler, useClass: AppErrorHandler },
        DatePipe, AppInsightsService
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
